import React, { useEffect, useState } from 'react';
import * as mobxReact from 'mobx-react';
import './number-filter.scss';
import { ReportConfigurationViewModel } from '../../../_reports/report-configuration/report-configuration.viewmodel';
import { IReportOperator, IReportOperatorItem } from '../../../../../../api/reports.dao';
import { NUMERICAL_1_TO_999_EXP } from '../../../../../../constants/regex.constants';

interface IProps {
    field: string;
    ContentHeader: JSX.Element;
    additionalLabel: string;
    configurationVm: ReportConfigurationViewModel;
}

const NumberFilter = mobxReact.observer((props: IProps) => {
    const {
        field,
        ContentHeader,
        additionalLabel,
        configurationVm,
    } = props;

    const operators: IReportOperatorItem[] = [{
        label: 'Greater than or equal to',
        value: 'MORE_THAN'
    }, {
        label: 'Less than',
        value: 'LESS_THAN'
    }];

    const { applyFilter, clearFilter, getAppliedFilter } = configurationVm;
    const appliedFilter = getAppliedFilter(field);
    const [operatorValue, setOperatorValue] = useState(operators[0].value);

    const filterCommonProps = {
        field: field,
        customField: false,
        operator: operatorValue,
    };

    const handleChangeValue = (value: string) => {
        let inputValue = appliedFilter?.values[0] || '';
        if (!value || NUMERICAL_1_TO_999_EXP.test(value)) {
            inputValue = value;
        }

        if (appliedFilter && !inputValue) {
            clearFilter(field);
        } else if (inputValue) {
            applyFilter({...filterCommonProps, values: [inputValue]});
        }
    };

    const handleChangeOperator = (value: IReportOperator) => {
        setOperatorValue(value);
        if (appliedFilter) applyFilter({...filterCommonProps, operator: value, values: appliedFilter.values});
    };

    useEffect(() => {
        if (appliedFilter) setOperatorValue(appliedFilter.operator);
    }, [field]);

    return (
        <div className='number-filter'>
            <div className='number-filter__header'>
                {ContentHeader}
                <div className='number-filter__header-content'>
                    <select
                        className='number-filter__operator-chooser oe-form-field__control'
                        value={operatorValue}
                        onChange={e => handleChangeOperator(e.target.value as IReportOperator)}
                    >
                        { operators.map(operator =>
                            <option key={operator.value} value={operator.value}>{operator.label}</option>
                        )}
                    </select>
                    <input
                        type='text'
                        className='number-filter__input oe-form-field__control'
                        value={appliedFilter?.values[0] || ''}
                        onChange={e => handleChangeValue(e.target.value)}
                    />
                    <div className='number-filter__label'>
                        {additionalLabel}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default NumberFilter;
